import { render } from "./App.vue?vue&type=template&id=dc86c1f8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=dc86c1f8&lang=css"
script.render = render

export default script